import { makeStyles } from '@material-ui/styles';
import { Skeleton } from '@bizzabo/design-system';

const WizardLoader: React.FC = () => {
    const classes = useStyles();

    return (
        <>
            <Skeleton className={classes.title} />
            <Skeleton className={classes.text} />
            <Skeleton className={classes.text} />
            <Skeleton className={classes.messageTitle} />
            <Skeleton className={classes.message} />
            <Skeleton className={classes.btnsTitle} />
            <div className={classes.container}>
                <Skeleton className={classes.btn} />
                <Skeleton className={classes.btn} />
            </div>
            <Skeleton className={classes.locationTitle} />
            <Skeleton className={classes.location} />
        </>
    );
};

const useStyles = makeStyles(
    () => ({
        title: {
            width: '80%',
            marginTop: 40,
            marginBottom: 14,
        },
        text: {
            width: '90%',
            marginBottom: 4,
        },
        messageTitle: {
            marginTop: 20,
            marginBottom: 8,
        },
        message: {
            height: 74,
            marginBottom: 11,
        },
        btnsTitle: {
            marginBottom: 8,
        },
        container: {
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 26,
        },
        btn: {
            width: '48%',
            height: 32,
        },
        locationTitle: {
            marginBottom: 8,
        },
        location: {
            height: 32,
        },
    }),
    { classNamePrefix: 'wizard-loader' }
);

export default WizardLoader;
